import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { adminApi } from "@/lib/api";

export default function RequireAdmin({ children }) {
  const [state, setState] = useState({ loading: true, ok: false });
  const loc = useLocation();
  useEffect(() => {
    adminApi.me().then(() => setState({ loading: false, ok: true }))
      .catch(() => setState({ loading: false, ok: false }));
  }, []);
  if (state.loading) {
    return <div style={{ padding: 40, fontFamily: "inherit", color: "#5C5C5C" }}>{"Loading\u2026"}</div>;
  }
  if (!state.ok) return <Navigate to="/admin/login" state={{ from: loc }} replace />;
  return children;
}
